module.exports = __webpack_public_path__ + "static/media/ppopular_white.f387bf72.png";